module.exports = __webpack_public_path__ + "static/media/noImage.624e9569.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/public/noImage.png
// module id = 115
// module chunks = 0